import sanitizeHtml from 'sanitize-html';
export const sanitize = (() => {
  const defaultConfigs = {
    allowedTags: ['address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'nav', 'section', 'div', 'hr', 'li', 'ol', 'p', 'pre', 'ul', 'a', 'br', 'em', 'i', 'mark', 'span', 'strong', 'sub', 'sup', 'u', 'caption', 'col', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'img', 'iframe'],
    disallowedTagsMode: 'discard',
    allowedAttributes: {
      a: ['href', 'name', 'target'],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
      iframe: ['src']
    },
    allowedIframeHostnames: ['www.youtube.com'],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
    // URL schemes we permit
    allowedSchemes: ['http', 'https', 'tel'],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
    allowProtocolRelative: true,
    enforceHtmlBoundary: true
  };
  return (data, configs) => {
    return sanitizeHtml(data, { ...defaultConfigs,
      ...configs
    });
  };
})();